module.exports = __webpack_public_path__ + "static/media/allalerts_test_hover.bfd892f1.svg";